import { ITemplateScope } from "AngularFormly";
import { RecordRepeaterController } from "./controller";

export interface ICopyDeleteScope extends ITemplateScope {
  addRow: (model?: number) => void;
  deleteRow: (model: number) => void;
  moveUp: (model: number) => void;
  moveDown: (model: number) => void;
}
export class RecordCopyDeleteController {
  static $inject = ["$scope"];

  constructor($scope: ICopyDeleteScope) {
    const repeaterController: RecordRepeaterController = (<any>(
      $scope.formState
    )).getRepeaterController();
    $scope.addRow = (model) => repeaterController.addRow(model);
    $scope.deleteRow = (model) => repeaterController.deleteRow(model);
    $scope.moveUp = (model) => repeaterController.moveUp(model);
    $scope.moveDown = (model) => repeaterController.moveDown(model);
  }
}
